import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Pagination } from '../models/pagination';
import { Report } from '../models/report';
import { FilterReportsForm } from '../pages/Reporting/FilterReports';

const baseUrl = '/reports';

const getReports = (
  data?: FilterReportsForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Report>>> =>
  axios.post<Pagination<Report>>(`${baseUrl}`, data, config);

const exportReport = (
  data?: FilterReportsForm
): Promise<AxiosResponse<string>> =>
  axios.post<string>(`${baseUrl}/export`, data, { responseType: 'blob' });

export const reportService = {
  getReports,
  exportReport
};
